import { render, staticRenderFns } from "./Messagerie.vue?vue&type=template&id=1650e23f&"
import script from "./Messagerie.js?vue&type=script&lang=js&"
export * from "./Messagerie.js?vue&type=script&lang=js&"
import style0 from "./Messagerie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports